import { useState } from "react";
import DoubleRightArrow from "../../../assets/DoubleRightArrow.svg";
import AI from "../../../assets/home/ai.svg";
import AutoLabel from "../../../assets/home/auto-label.svg";
import IngredientDetails from "../../../assets/home/IngredientDetails.png";
import nfpLabeL from "../../../assets/home/nfp-label.png";
import OneClick from "../../../assets/home/one-click.svg";
import RecipeList from "../../../assets/home/RecipeList.png";
import "./style.css";

export default function ProblemSolution() {
    const [activeId, setActiveId] = useState(1);
    const [blinkId, setBlinkId] = useState(null);

    const content = [
        {
            id: 1,
            icon: AutoLabel,
            headerText: "Auto‑Label Builder",
            description: "FDA, CFIA, EU formats in one click.",
        },
        {
            id: 2,
            icon: AI,
            headerText: "Ingredient Intelligence ",
            description: "Live database flags allergen & Prop 65 risks.",
        },
        {
            id: 3,
            icon: OneClick,
            headerText: "One‑Click Audit Pack",
            description: "Pull every spec, cert, and change log into a PDF.",
        },
    ];

    const imageList = {
        1: nfpLabeL,
        2: IngredientDetails,
        3: RecipeList,
    };

    const handleClick = (id) => {
        setActiveId(id);
        if (activeId && activeId != id) {
            setBlinkId(id);
            setTimeout(() => setBlinkId(null), 400);
        }
    };

    return (
        <div className="d-flex justify-content-center">
            <div className="commonInlinePadding problemContainer section-container">
                <div className="flexCenter">
                    <div className="boxContainer">
                        <div className="dot" />
                        <div className="typography">Problem</div>
                        <img src={DoubleRightArrow} alt="DoubleRightArrow" />
                        <div className="typography">Solution</div>
                    </div>
                </div>
                <div className="off-black problemHeading">
                    Manual nutrition entry, messy version control, <br /> last‑minute label fixes…{" "}
                    <span className="purpleLinearGradient">sound familiar? </span>
                </div>
                <div
                    className="Caption off-black"
                    style={{ textAlign: "center", marginBottom: "5rem", opacity: "0.6" }}
                >
                    We Looked for Solutions & Turned Them Into Features
                </div>

                <div className="mainShowCase">
                    <div className="showcase">
                        {content?.map((item) => {
                            return (
                                <div
                                    className={`solutionContainer ${activeId === item?.id ? "activeBorder" : "noOpacity"} ${blinkId === item?.id ? "blink" : ""}`}
                                    onClick={() => handleClick(item?.id)}
                                    key={item.id}
                                >
                                    <div className="iconContainer">
                                        <img src={item?.icon} alt="AI" />
                                    </div>

                                    <div>
                                        <div
                                            className="off-black extra-large"
                                            style={{ fontWeight: "700" }}
                                        >
                                            {item?.headerText}
                                        </div>
                                        <div className="off-black medium" style={{ opacity: "0.5" }}>
                                            {item?.description}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    <div className="imageContainerForProblem">
                        <img src={imageList[activeId]} alt="nfpLabeL" />
                    </div>
                </div>
            </div>
        </div>
    );
}
